var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{class:`padding-16 border-radius-8 flex-center ${_vm.bg}`},[_c('b-spinner',{attrs:{"small":""}}),_c('strong',{staticClass:"margin-right-8",domProps:{"textContent":_vm._s(_vm.text)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }